import type { PromptConfig } from "website_script/types/settings"
import type { ButtonConfig } from "website_script/types/widgets"

/**
 * Picks what prompt has priority based on the
 * associated button (buttons are ordered).
 */
export const getTopPrompt = (
  prompts: PromptConfig[],
  buttons: ButtonConfig[]
) => {
  const buttonsAndPromptsById = new Map<
    number,
    { buttonConfig: ButtonConfig; promptConfig?: PromptConfig }
  >()

  buttons.forEach((buttonConfig) => {
    buttonsAndPromptsById.set(buttonConfig.lead_flow_id, {
      buttonConfig,
      promptConfig: prompts.find(
        (promptConfig) =>
          promptConfig.lead_flow_id === buttonConfig.lead_flow_id
      ),
    })
  })

  const buttonConfig: ButtonConfig | undefined = buttons.find(
    (buttonConfig) =>
      buttonsAndPromptsById.get(buttonConfig.lead_flow_id)!.promptConfig !==
      undefined
  )

  const promptConfig =
    buttonConfig &&
    buttonsAndPromptsById.get(buttonConfig.lead_flow_id)!.promptConfig

  return { buttonConfig, promptConfig }
}
